import React from "react"
import PropTypes from "prop-types"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faMinusCircle } from "@fortawesome/free-solid-svg-icons"
import BooleanCell from "./BooleanCell"

const TernaryCell = ({ value, icon }) =>
  value === null || value === undefined ? (
    !!icon ? (
      <FontAwesomeIcon icon={faMinusCircle} color="gray" />
    ) : (
      "-"
    )
  ) : (
    <BooleanCell value={value} />
  )

TernaryCell.propTypes = {
  icon: PropTypes.bool
}

TernaryCell.defaultProps = {
  icon: true
}

export default TernaryCell
